import S_systemClassAnalysis from '@/service/api/v1/systemclass_analysis';
import H_time from '@/helpers/time';
import H_card from "@/helpers/card";
import H_file from '@/helpers/file';
import H_common from '@/helpers/common';
import H_guidelineVersionAdmin from '@/helpers/guidelineVersionAdmin';
import H_systemClassMenu from '@/helpers/systemClassMenu';

export default {
  getCard(audits, isTemplate, factorySystemClassRows = []) {
    audits = S_systemClassAnalysis.userSystemSubclassesAuthCheck(audits)
    if (!audits || audits.length === 0) return [];
    const data = audits.map((audit) => {
      const {
        id,
        name: title,
        system_classes,
        system_subclasses,
        factory_system_classes,
        factory_system_subclasses,
        owner,
        is_collect: isCollect,
      } = audit;
      let resultAudit = {
        id,
        title,
        tags: H_systemClassMenu.formatMultiSystemClassCardTags(
          { system_classes, system_subclasses, factory_system_classes, factory_system_subclasses },
          { factorySystemClassRows },
        ),
      }
      if (isTemplate) {
        resultAudit = {
          ...resultAudit,
          spec: [
            {
              title: '更新日期',
              text: H_time.getDateDashFormat(audit.last_version.updated_at),
            },
            {
              title: '引用數量',
              text: audit.related_count,
            },
          ],
          chips: H_card.setTags(audit, ['updated', 'status'])
        }
      } else {
        const templateId =
          audit.last_version && audit.last_version.audit_template_version
            ? audit.last_version.audit_template_version.id
            : 0;
        const templateVersionId =
          audit.audit_template && audit.audit_template.last_version
            ? audit.audit_template.last_version.id
            : 0;
        resultAudit = {
          ...resultAudit,
          spec: [{
            title: '管理者',
            text: owner ? owner.name : '',
          }],
          chips: templateId && templateVersionId && templateId !== templateVersionId
            ? [{
                color: 'yellow',
                text: '版本更新',
              }]
            : [],
          isCollect,
        }
      }
      return resultAudit;
    });
    return data;
  },
  setFetchQues(rawQue, isUpdateQues = false) {
    const ques = rawQue.audit_question
    const quesTemplateVersion = rawQue.audit_question_template_version
    let resultQues = {
      title: rawQue.title,
      versionId: rawQue.id,
      payload: rawQue.payload,
      focus: rawQue.keypoint,
      images: H_file.setShowInModule(rawQue.file_images),
      attaches: H_file.setShowInModule(rawQue.file_attaches),
      articles: rawQue.article_versions,
      remark: rawQue.remark,
      riskSignal: [[...rawQue.effects],[...rawQue.factory_effects]],
      acts: rawQue.act_version_alls,
      templateVersionId: rawQue.templateVersionId,
      act_version_alls: rawQue.act_version_alls,
      act_versions: rawQue.act_versions,
      article_versions: rawQue.article_versions,
      templateId: rawQue.templateId,
      lawList: [],
      hasFetch: true,
      tempImages: H_file.setTempFileShowInModule(rawQue.template_images),
      tempAttaches: H_file.setTempFileShowInModule(rawQue.template_attaches),
      guidelineList: isUpdateQues
        ? H_guidelineVersionAdmin.setUpdateRelatedGuideline(rawQue.related_guidelines)
        : H_guidelineVersionAdmin.setShowRelatedGuideline(rawQue.related_guidelines),
    }
    if (ques && ques.audit_question_template) {
      resultQues = {
        ...resultQues,
        templateId: ques.audit_question_template.id,
      }
    }
    if (quesTemplateVersion) {
      resultQues = {
        ...resultQues,
        templateVersionId: quesTemplateVersion.id,
      }
    }
    resultQues.lawList = H_common.setLawList(resultQues);
    return resultQues
  },
}
